import jump from 'jump.js'

export default valentinesGiftGuide22Nav => {
  // Main nav selectors, broken into type - Separated into Desktop and Mobile
  let ggNavByPriceDesktop = document.querySelector('#valentines-22_nav_desktop div[data-gg-choice="price"]')
  let ggNavByPriceMobile = document.querySelector('#valentines-22_nav_mobile div[data-gg-choice="price"]')

  let ggNavSubtierByPriceDesktop = document.querySelector('#valentines-22_nav_desktop div[data-gg-subchoice="price"]')
  let ggNavSubtierByPriceMobile = document.querySelector('#valentines-22_nav_mobile div[data-gg-subchoice="price"]')

  // All Nav items, broken into type - Desktop and Mobile
  let ggNavByPriceTiers = document.querySelectorAll('[data-gg-price-tier]')

  // Sections on Page - Desktop and Mobile
  let ggByPriceSection = document.querySelector('[data-gg-type="sbprice"]')

  // Shop by Price Desktop click event listener
  if (ggNavByPriceDesktop) {
    ggNavByPriceDesktop.addEventListener('click', () => {
      ggNavByPriceDesktop.classList.add('active')
      ggNavSubtierByPriceDesktop.classList.add('active')
      ggByPriceSection.classList.add('active')
      jump(`#shop-by-price`, { offset: -150, duration: 100 })

      // // Adding in GTM/GA pageview tracking via datalayer
      // window.dataLayer.push({
      //   event: 'pageview',
      //   page: {
      //     path: '/pages/holiday-gift-guide#shop-by-price',
      //     title: 'Holiday Gift Guide - Shop by Price'
      //   }
      // })
    })
  }
  // Shop by Price Mobile click event listener
  ggNavByPriceMobile.addEventListener('click', () => {
    ggNavByPriceMobile.classList.add('active')
    ggNavSubtierByPriceMobile.classList.add('active')
    ggByPriceSection.classList.add('active')
    jump(`#shop-by-price`, { offset: 0, duration: 100 })
    // // Adding in GTM/GA pageview tracking via datalayer
    // window.dataLayer.push({
    //   event: 'pageview',
    //   page: {
    //     path: '/pages/holiday-gift-guide#shop-by-price',
    //     title: 'Holiday Gift Guide - Shop by Price'
    //   }
    // })
  })

  // Shop by Price subtier click event listeners - Desktop and Mobile
  ggNavByPriceTiers.forEach(tier => {
    tier.addEventListener('click', () => {
      ggNavByPriceTiers.forEach(tier => {
        tier.classList.remove('active')
      })
      tier.classList.add('active')
      ggNavByPriceMobile.classList.add('active')
      ggNavSubtierByPriceMobile.classList.add('active')
      ggByPriceSection.classList.add('active')
    })
  })
  // URL Hashing Logic to allow linking straight to certain tiers
  let urlHash = window.location.hash.split('#')[1]

  // Set up logic for url hash
  if (urlHash) {
    if (urlHash === 'gifts-under-50' || urlHash === 'gifts-under-100' || urlHash === 'gifts-under-200' || urlHash === 'gifts-under-300') {
      // ggNavByPriceDesktop.classList.add('active')
      // ggNavByPriceMobile.classList.add('active')
      ggNavSubtierByPriceDesktop.classList.add('active')
      ggNavSubtierByPriceMobile.classList.add('active')
      ggByPriceSection.classList.add('active')
      ggNavByPriceTiers.forEach(tier => {
        tier.classList.remove('active')
      })
      ggNavByPriceTiers.forEach(tier => {
        if (tier.dataset.ggPriceTier === urlHash) {
          tier.classList.add('active')
        }
      })
    }

    if (window.innerWidth < 769) {
      jump(`#${urlHash}`, { offset: 0, duration: 100 })
    } else {
      jump(`#${urlHash}`, { offset: -200, duration: 100 })
    }
  }
}

// Nav sticky functionality
let hggNav = document.querySelector('#valentines-22_nav')
let origOffsetY = hggNav.offsetTop
let collectionContainer = document.querySelector('.collection-parent-container')
let header = document.querySelector('#header')
let headerHeight = header.offsetHeight
let promoBar = document.querySelector('#shopify-section-announcement-bar')
let promoBarHeight
if (promoBar) {
  promoBarHeight = promoBar.offsetHeight
}

function onScroll (e) {
  if (window.scrollY >= origOffsetY - headerHeight - promoBarHeight) {
    hggNav.classList.add('sticky')
    collectionContainer.classList.add('sticky')
  } else {
    hggNav.classList.remove('sticky')
    collectionContainer.classList.remove('sticky')
  }
}
document.addEventListener('scroll', onScroll)



// WEBPACK FOOTER //
// ./src/scripts/components/valentines-gift-guide-22-nav.js